import { ChangeDetectionStrategy, Component, Input, inject, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngxs/store';
import { switchMap, take } from 'rxjs';
import {
  DEFAULT_DATE_TIME_SECONDS_FORMAT,
  SHORT_TIME_FORMAT,
} from 'src/app/core/ccomx-date-formats';
import { UserTasksRoutes } from 'src/app/core/enums/routes.enum';
import { IAttachment } from 'src/app/shared/attachments/models/attachments.model';
import { AttachmentService } from 'src/app/shared/attachments/service/attachments.service';
import { UiAttachmentsComponent } from 'src/app/shared/attachments/ui-attachments.component';
import { TaskActionType } from 'src/app/task-user/components/enum/task-action-type';
import { LoadHaccpPerform } from 'src/app/task-user/state/haccp.actions';
import { HaccpState } from 'src/app/task-user/state/haccp.state';

@Component({
  selector: 'app-task-log-template',
  templateUrl: './task-log-template.component.html',
  styleUrls: ['./task-log-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TaskLogTemplateComponent {
  private readonly injector = inject(Injector);

  @Input() columnName: string;
  @Input() element: any;

  taskActionTypes = TaskActionType;
  performViewRoute = UserTasksRoutes.PerformView;
  dateFormat = DEFAULT_DATE_TIME_SECONDS_FORMAT;
  timeFormat = SHORT_TIME_FORMAT;

  private readonly haccpPerformState = select(HaccpState.getPerform);

  constructor(
    private dialog: MatDialog,
    private store: Store
  ) {}

  openAttachments(): void {
    this.store
      .dispatch(new LoadHaccpPerform(this.element.haccpId, this.element.workVersionId))
      .pipe(
        switchMap(() => toObservable(this.haccpPerformState, { injector: this.injector })),
        take(1)
      )
      .subscribe((perform) => {
        if (!perform) return;
        const dialogRef = this.dialog.open(UiAttachmentsComponent, {
          panelClass: 'mobile-sizing-for-mat-dialogs',
        });
        dialogRef.componentInstance.attachments = new FormControl<IAttachment[]>(
          AttachmentService.mapAttachments(perform.attachments)
        ) as any;
        dialogRef.componentInstance.editMode = false;
        dialogRef.componentInstance.passiveMode = true;
      });
  }
}
